// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js"
import { MouseButtons } from "../UtilsClasses/ControlsUtils.js"
import { contextMenuHandler } from "../../Utils/AppHandlers.js"
import { TradingButtonStripeTemplate } from "../../templates.js"
import { Control } from "./Control.js"

export let TradingButtonStripe = Control.extend({
    data: function ()
    {
        return {
            showHiddenItemsMessage: false,
            hiddenItemsMessage: '',
            actionArray: [],
            actionDataDict: {},
            buttonWidth: 100,
            buttonHeight: 22
        }
    },
    template: TradingButtonStripeTemplate
})

TradingButtonStripe.prototype.getType = function () { return 'TradingButtonStripe' }

TradingButtonStripe.prototype.oninit = function ()
{
    Control.prototype.oninit.call(this)
    this.on('tradingButtonClick', this.onTradingButtonClick)
    this.onMenuItemClicked = this.onMenuItemClicked.bind(this)
    this.observe('actionDataDict.*.visible', this.onVisibilityChanged)
    Resources.onLocaleChange.Subscribe(this.localize, this)
    this.localize()
}

TradingButtonStripe.prototype.dispose = function ()
{
    Resources.onLocaleChange.UnSubscribe(this.localize, this)

    Control.prototype.dispose.call(this)
}

TradingButtonStripe.prototype.localize = function ()
{
    let key = 'panels.positions.ButtonsPanel.helpLabel'
    this.set(
        'hiddenItemsMessage',
        Resources.isHidden(key) ? '' : Resources.getResource(key))

    let actionDataDict = this.get('actionDataDict')
    if (!actionDataDict)
        return

    for (let action in actionDataDict)
    {
        let data = actionDataDict[action]
        data.text = Resources.getResource(data.locKey)
        data.tooltip = data.tooltipLocKey ? Resources.getResource(data.tooltipLocKey) : '';
    }
    this.update('actionDataDict')
}

// TODO. Ugly.
TradingButtonStripe.prototype.onMouseDown = function (event, isHeader)
{
    if (Control.IsEventProcessed(event))
        return

    let origEvt = event.original

    Control.prototype.onMouseDown.call(this, event, isHeader)

    if (origEvt.button === MouseButtons.Right)
    {
        contextMenuHandler.Show(
            this.getMenuItems(),
            origEvt.clientX,
            origEvt.clientY,
            { isMultiClick: true })
    }

    Control.ProcessEvent(event)
}

// TODO. Optimize?
TradingButtonStripe.prototype.getMenuItems = function ()
{
    let actionArr = this.get('actionArray')
    let actionDataDict = this.get('actionDataDict')
    let menuItemArr = []
    for (let i = 0, len = actionArr ? actionArr.length : 0; i < len; i++)
    {
        let action = actionArr[i]
        let data = actionDataDict[action]

        menuItemArr.push({
            text: Resources.getResource(data.locKey),
            enabled: true,
            localizeKey: data.locKey,
            canCheck: true,
            checked: data.visible,
            tag: action,
            event: this.onMenuItemClicked
        })
    }

    return menuItemArr
}

TradingButtonStripe.prototype.onMenuItemClicked = function (menuItem)
{
    let action = menuItem.tag
    this.set('actionDataDict.' + action + '.visible', menuItem.checked)
}

// TODO. Optimize.
TradingButtonStripe.prototype.onVisibilityChanged = function ()
{
    let actionArr = this.get('actionArray')
    let actionDataDict = this.get('actionDataDict')
    let visibleItemCount = 0
    let len = actionArr ? actionArr.length : 0
    for (let i = 0; i < len; i++)
    {
        let action = actionArr[i]
        let data = actionDataDict[action]
        data.visibilityIdx = data.visible ? visibleItemCount++ : i
    }

    this.set('showHiddenItemsMessage', !visibleItemCount)
    this.update('actionDataDict')
}

// TODO. Meh.
TradingButtonStripe.prototype.setItemArray = function (itemArray)
{
    let actionArr = []
    let actionDataDict = {}
    for (let i = 0, len = itemArray ? itemArray.length : 0; i < len; i++)
    {
        let item = itemArray[i]
        let action = item.action
        if (Resources.isHidden(item.locKey))
            continue;
        actionArr.push(action)
        actionDataDict[action] =
        {
            action: action,
            enabled: item.enabled,
            visible: item.visible,
            visibilityIdx: i,
            instrument: item.instrument,
            locKey: item.locKey,
            text: Resources.getResource(item.locKey)
        }
    }

    this.set({
        actionArray: actionArr,
        actionDataDict: actionDataDict
    })
}

// TODO. Ugly. Refactor.
TradingButtonStripe.prototype.updateEnability = function (enabledActionSet)
{
    if (!enabledActionSet) return

    let actionDataDict = this.get('actionDataDict')
    if (!actionDataDict) return

    for (let actionKey in actionDataDict)
    {
        if (!enabledActionSet[actionKey])
            continue;

        const actionData = actionDataDict[actionKey]
        actionData.enabled = enabledActionSet[actionKey].Allowed;
        actionData.tooltipLocKey = enabledActionSet[actionKey].ReasonLocalizationKey;
        actionData.tooltip = enabledActionSet[actionKey].ReasonText;
    }

    this.update('actionDataDict')
}

TradingButtonStripe.prototype.setInstrument = function (action, instrument)
{
    let actionDataDict = this.get('actionDataDict')
    if (!actionDataDict) return

    let actionData = actionDataDict[action]
    if (!actionData) return

    actionData.instrument = instrument

    this.update('actionDataDict')
}

// TODO. Refactor. Rename evants.
TradingButtonStripe.prototype.onTradingButtonClick = function (action)
{
    this.fire('tradingAction', action)
}

TradingButtonStripe.prototype.getBtnsVisibility = function ()
{
    let result = [];
    let actionDataDict = this.get('actionDataDict')
    if (!actionDataDict) return result;
    for (let actionKey in actionDataDict)
        result.push({ a: actionKey, v: actionDataDict[actionKey].visible });

    return result;
}

TradingButtonStripe.prototype.setBtnsVisibility = function (data)
{
    if (!data)
        return;

    let actionDataDict = this.get('actionDataDict')
    if (!actionDataDict)
        return;

    for (let i = 0; i < data.length; i++)
    {
        let action = data[i].a;
        let visible = data[i].v;
        if (actionDataDict[action])
            actionDataDict[action].visible = visible;
    }
}

// #region TradingButtonItem

export let TradingButtonItem = function (action, locKey, instrument, enabled, visible)
{
    this.action = action
    this.locKey = locKey
    this.instrument = instrument || null
    this.enabled = enabled === undefined ? false : !!enabled
    this.visible = visible === undefined ? true : !!visible
}

// #endregion TradingButtonItem